module.exports = __webpack_public_path__ + "static/img/CT_2.0204662b.png";